import type {FC} from 'react';
import {memo} from 'react';

import StarIconSVG from '@yourcoach/shared/assets/icons/star.svg';

interface Props {
  customClass?: string;
  height?: string;
  width?: string;
}

const StarIcon: FC<Props> = ({
  customClass = '',
  height = '100%',
  width = '100%',
}) => {
  return (
    <StarIconSVG
      className={`${customClass}`}
      fill="#ffffff73"
      height={width}
      width={height}
    />
  );
};

export default memo(StarIcon);
